(function() {
  var track = document.getElementById('vwoCatTrack');
  var outer = document.getElementById('vwoCatTrackOuter');
  var prevBtn = document.getElementById('vwoCatPrev');
  var nextBtn = document.getElementById('vwoCatNext');

  if (!track || !outer || !prevBtn || !nextBtn) return;

  var isDragging = false;
  var dragStartX = 0;
  var dragStartScrollLeft = 0;
  var didDrag = false;

  function getSlideWidth() {
    var slide = track.querySelector('.vwo-cat-slide');
    if (!slide) return 0;

    var trackStyles = window.getComputedStyle(track);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);

    return slide.offsetWidth + gap;
  }

  function getMaxScrollLeft() {
    return Math.max(0, outer.scrollWidth - outer.clientWidth);
  }

  function updateNavButtons() {
    var maxScrollLeft = getMaxScrollLeft();
    var currentScrollLeft = outer.scrollLeft;
    var scrollBuffer = 2;

    if (currentScrollLeft > scrollBuffer) {
      prevBtn.classList.add('visible');
    } else {
      prevBtn.classList.remove('visible');
    }

    if (currentScrollLeft >= maxScrollLeft - scrollBuffer) {
      nextBtn.style.opacity = '0.35';
      nextBtn.style.pointerEvents = 'none';
    } else {
      nextBtn.style.opacity = '1';
      nextBtn.style.pointerEvents = 'all';
    }
  }

  function scrollBySlide(direction) {
    var slideWidth = getSlideWidth();
    var amount = slideWidth || outer.clientWidth * 0.8;

    outer.scrollTo({
      left: outer.scrollLeft + (amount * direction),
      behavior: 'smooth'
    });
  }

  prevBtn.addEventListener('click', function() {
    scrollBySlide(-1);
  });

  nextBtn.addEventListener('click', function() {
    scrollBySlide(1);
  });

  outer.addEventListener('scroll', updateNavButtons, { passive: true });

  outer.addEventListener('mousedown', function(e) {
    isDragging = true;
    didDrag = false;
    dragStartX = e.clientX;
    dragStartScrollLeft = outer.scrollLeft;
    outer.classList.add('dragging');
  });

  document.addEventListener('mousemove', function(e) {
    if (!isDragging) return;

    var diff = e.clientX - dragStartX;

    if (Math.abs(diff) > 5) {
      didDrag = true;
      e.preventDefault();
    }

    outer.scrollLeft = dragStartScrollLeft - diff;
  });

  function endDrag() {
    if (!isDragging) return;

    isDragging = false;
    outer.classList.remove('dragging');
    updateNavButtons();
  }

  document.addEventListener('mouseup', endDrag);
  document.addEventListener('mouseleave', endDrag);
  document.addEventListener('dragend', endDrag);

  outer.addEventListener('click', function(e) {
    if (didDrag) {
      e.preventDefault();
      e.stopPropagation();
      didDrag = false;
    }
  }, true);

  window.addEventListener('resize', updateNavButtons);

  updateNavButtons();
})();
